import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const NavLinkCustom = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 175px;
  height: 35px;
  border-radius: 10px;
  border: 2px solid var(--white-color);
  color: var(--white-color);
  font-size: 0.875rem;
`;
